import { parse } from 'query-string';

export const getDimension = search => {
  const { dimension } = parse(search);
  return dimension || 'Property';
};
